<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { toast, toastState } from 'dashboard/composables/useToast';
import ToastItem from './ToastItem.vue';

// Palco dos toasts. Desktop: canto inferior direito, o mais novo por baixo,
// no máximo 3 legíveis (os antigos esmaecem). Celular: entra pelo topo,
// um por vez — a barra de abas e o teclado moram embaixo.
const MAX_VISIBLE = 3;
const MOBILE_QUERY = '(max-width: 767px)';

const isMobile = ref(false);
let mql = null;
const syncMobile = () => {
  isMobile.value = Boolean(mql?.matches);
};

const items = computed(() => {
  const list = toastState.items;
  if (isMobile.value) return list.slice(-1);
  return list.slice(-6);
});

const isFaded = index =>
  !isMobile.value && items.value.length - index > MAX_VISIBLE;

const onKeydown = event => {
  if (event.key !== 'Escape' || !toastState.items.length) return;
  toast.dismiss(toastState.items[toastState.items.length - 1].id);
};

onMounted(() => {
  mql = window.matchMedia(MOBILE_QUERY);
  syncMobile();
  mql.addEventListener('change', syncMobile);
  document.addEventListener('keydown', onKeydown);
});

onUnmounted(() => {
  mql?.removeEventListener('change', syncMobile);
  document.removeEventListener('keydown', onKeydown);
});
</script>

<template>
  <div
    class="fixed z-[9999] flex flex-col gap-2 pointer-events-none"
    :class="
      isMobile
        ? 'top-3 left-3 right-3'
        : 'bottom-4 right-4 w-[min(24rem,calc(100vw-2rem))]'
    "
  >
    <ToastItem
      v-for="(item, index) in items"
      :key="item.id"
      :item="item"
      :mobile="isMobile"
      :faded="isFaded(index)"
      @dismiss="toast.dismiss(item.id)"
    />
  </div>
</template>
